import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { useTranslation } from 'react-i18next';
import { coreApi } from '../../api';

const useUpdateBrokerageLogo = () => {
  const { t } = useTranslation();

  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['brokerageUpdateLogo'],
    mutationFn: (body: { brokerageExternalId: string, logo: File }) => {
      const formData = new FormData();
      formData.append('logo', body.logo);
      return coreApi.updateBrokerageLogo(body.brokerageExternalId, formData);
    },
    onSuccess: (_) => {
      toast('info', { message: t('account.updatedLogoSuccess') });
    },
  });

  useEffect(() => {
    if (!error) return;
    const logoError = error?.data?.logo;
    if (logoError?.file_name) {
      toast('error', { message: t('account.fileErrorName') });
    }
    if (logoError?.max_size) {
      toast('error', { message: t('account.fileErrorSize') });
    }
    if (!logoError) {
      toast('error', { message: error.message });
    }
  }, [error, t]);

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useUpdateBrokerageLogo;
